import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import SearchField from 'components/atoms/SearchField'
import DataTable from 'components/organisms/DataTable'
import PaginationControl from 'components/organisms/PaginationControl'
import { filterActiveTraps } from 'utils/misc'
import { trapColumns } from './'

export const styles = theme => ({
  root: {},
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inviteButton: {
    ...theme.components.headerButton,
  },
  table: {
    marginTop: theme.spacing(6),
  },
})

const ManageTraps = ({
  traps,
  classes,
  filters,
  bulkSelected,
  onBulkSelect,
  onPageChange,
  selectedTraps,
  onSearchChange,
  onTableRowClick,
  onTableSortClick,
  onTableSelectableClick,
  onShareClick,
  unsetAllTraps,
}) => {
  const filteredTraps = useMemo(() => traps && filterActiveTraps(traps), [traps])

  const handlePageChange = (offset) => {
    unsetAllTraps()      
    onPageChange(offset)
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h1">All Traps</Typography>
        <div style={{ display: 'inherit' }}>
          <SearchField onChange={onSearchChange} />
        </div>
      </div>
      <DataTable
        headerProps={{
          bulkSelected,
          onBulkSelect,
        }}
        key="Trap table"
        dataProvider={filteredTraps}
        columns={trapColumns}
        className={classes.table}
        onRowClick={onTableRowClick}
        onSortClick={onTableSortClick}
        rowComponentProps={{
          selectedItemKey: 'historyUuid',
          selectedItems: selectedTraps,
        }}
        handleShare={onShareClick}
        emptyStateLinkLabel="Invite contributors"
        emptyStateLinkTo="/dashboard/people/all"
        onSelectableClick={onTableSelectableClick}
        emptyStateTitle="Looks like there are no traps added yet"
        emptyStateDescription="Get started by sharing an invite code with Goodnature Chirp App users so they can share traps with you"
      />
      <PaginationControl
        pagination={filters.pagination}
        onPageChange={handlePageChange}
      />
    </div>
  ) 
}

ManageTraps.propTypes = {
  traps: PropTypes.object,
  classes: PropTypes.object,
  filters: PropTypes.object,
  bulkSelected: PropTypes.bool,
  onBulkSelect: PropTypes.func,
  onPageChange: PropTypes.func,
  selectedTraps: PropTypes.array,
  onSearchChange: PropTypes.func,
  onTableRowClick: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
  onShareClick: PropTypes.func,
  unsetAllTraps: PropTypes.func,
}

export default withStyles(styles)(ManageTraps)



// WEBPACK FOOTER //
// ./src/containers/traps/ManageTraps/ManageTraps.js